import type { PricingVersionFormat, PricingVersionTuple } from '../../model/model.ts'

type EsMrpaxePricingVersionFormat = PricingVersionFormat<'es-mrp-axeria'>

export const esMrpaxePricingVersions = [
  ['pricing-es-mrp-axeria-1.0.0-2026-10-11', { label: 'Version 1' }],
  ['pricing-es-mrp-axeria-1.1.0-2026-11-06', { label: 'Version 1.1 - Raise default management fees to 15%' }],
] as const satisfies PricingVersionTuple<EsMrpaxePricingVersionFormat>[]

export type EsMrpaxePricingVersion = (typeof esMrpaxePricingVersions)[number][0]
